import axios from "axios";
import { toast } from "react-toastify";

var toastShown = false;

export function apiOperacao(operacao: string) {

  const token = localStorage.getItem(`x-nz-token-${operacao}`) ?? ""
  const tokenEmpresa = localStorage.getItem(`x-nz-empresa`) ?? ""

  return axios.create({
    baseURL: "/api",
    headers: { "authorization": `Bearer ${token}`, "empresa": tokenEmpresa },
    maxContentLength: (100 * 1024 * 1024),
    validateStatus: function (status) {

      if (status === 401 || status === 403 || status === 405) {

        if (!toastShown) {

          const message = status === 401
            ? "Você não possui permissão para acessar este recurso. Entre em contato com o administrador."
            : status === 405
              ? "Sua sessão expirou. Faça login novamente para continuar."
              : "Acesso negado. A empresa informada não está vinculada às suas permissões.";

          toast.error(message);

          toastShown = true;

          setTimeout(() => { toastShown = false; }, 3000);

        }

        return false;

      }

      return true;

    }

  });

}

export const api = axios.create({
  headers: { "authorization": `Bearer ${localStorage.getItem('x-nz-token-api') ?? ""}` },
  maxContentLength: (100 * 1024 * 1024),
  validateStatus: function (status) {
    if (status == 401) {
      localStorage.removeItem('x-nz-token-api');
      if (window.location.pathname != "/") {
        window.location.href = "/";
      }
      return true;
    }
    return true;
  },
});

export const api_adm = axios.create({
  headers: { "authorization": `Bearer ${localStorage.getItem('x-nz-token-admin') ?? ""}` },
  maxContentLength: (100 * 1024 * 1024),
  validateStatus: function (status) {
    if (status == 401) {
      localStorage.removeItem('x-nz-token-admin');
      if (window.location.pathname != "/") {
        window.location.href = "/";
      }
      return true;
    }
    return true;
  },
});

export const api_2fa = axios.create({
  headers: { "authorization": `Bearer ${localStorage.getItem('x-nz-token-2fa') ?? ""}` },
  maxContentLength: (100 * 1024 * 1024),
  validateStatus: function (status) {
    if (status == 401) {
      localStorage.removeItem('x-nz-token-2fa');
      if (window.location.pathname != "/") {
        window.location.href = "/";
      }
      return true;
    }
    return true;
  },
});

export const api_repre = axios.create({
  headers: { "authorization": `Bearer ${localStorage.getItem('x-nz-token-repre') ?? ""}` },
  maxContentLength: (100 * 1024 * 1024),
  validateStatus: function (status) {
    if (status == 401) {
      localStorage.removeItem('x-nz-token-repre');
      if (window.location.pathname != "/") {
        window.location.href = "/";
      }
      return true;
    }
    return true;
  },
});